<script setup>
import { tv } from 'tailwind-variants';
import { computed } from 'vue';
import { CsTransitionChild } from '../transition';
import { useDrawerContext } from './useDrawer';

const { rootProps, hasDrawerHeader, hasDrawerFooter } = useDrawerContext();

const drawerRecipe = tv({
  slots: {
    root: 'fixed z-modal inset-0 overflow-hidden pointer-events-none',
    container: 'absolute inset-0 overflow-hidden',
    content:
      'pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 transition-all',
    body: 'pointer-events-auto w-screen shadow-brand-600',
    bodyContent: 'flex h-full flex-col overflow-y-hidden bg-brand-background',
  },
  variants: {
    size: {
      sm: {
        body: 'max-w-[380px]',
      },
      md: {
        body: 'max-w-[485px]',
      },
      lg: {
        body: 'max-w-[620px]',
      },
      xl: {
        body: 'max-w-[980px]',
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

const drawerClasses = computed(() =>
  drawerRecipe({
    size: rootProps.value.size,
  })
);
</script>

<template>
  <div
    data-slot="root"
    :class="drawerClasses.root()"
    :style="{
      '--modal-header-height': hasDrawerHeader ? '45px' : '0px',
      '--modal-footer-height': hasDrawerFooter ? '60px' : '0px',
    }"
  >
    <div data-slot="container" :class="drawerClasses.container()">
      <div data-slot="content" :class="drawerClasses.content()">
        <CsTransitionChild
          enter-active-class="transform transition ease-in-out duration-300"
          enter-class="translate-x-full"
          enter-to-class="translate-x-0"
          leave-active-class="transform transition ease-in-out duration-200"
          leave-class="translate-x-0"
          leave-to-class="translate-x-full"
        >
          <div data-slot="body" :class="drawerClasses.body()">
            <div data-slot="body-content" :class="drawerClasses.bodyContent()">
              <slot />
            </div>
          </div>
        </CsTransitionChild>
      </div>
    </div>
  </div>
</template>
